/**
 * Google Analytics 4 (GA4) — Consent Mode v2 wiring
 *
 * The GA4 tag itself is loaded directly from index.html (so Google's tag
 * verification can detect it in the served HTML). To stay CIPA-compliant we
 * use Consent Mode: the default consent state is "denied" (set in index.html)
 * and this module flips `analytics_storage` to "granted" only after the user
 * grants Analytics consent in the cookie banner.
 */

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

import { consentManager } from './consentManager';

let wired = false;

export function initAnalytics(): void {
  if (wired || typeof window === 'undefined') return;
  wired = true;

  const apply = (granted: boolean) => {
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: granted ? 'granted' : 'denied',
      });
    }
  };

  // Apply the current consent state immediately (e.g. a returning visitor who
  // already granted Analytics consent on a previous visit).
  apply(consentManager.isConsented('analytics'));

  // Keep GA in sync with consent changes from the cookie banner / settings.
  consentManager.subscribe((state) => {
    apply(state.analytics);
  });
}
